import { SkeletonBlock, SkeletonText } from '@nucleus/web-theme-elements';
import React from 'react';
import styled from 'styled-components';
import { cornerStyleInterpolationFactory } from '../lib/cornerStyle';

export const SermonGridItemSkeleton = (): JSX.Element => {
  return (
    <Container>
      <ThumbnailPlaceholder />
      <Meta>
        <SkeletonText width="70%" style={{ height: 14, marginBottom: 8 }} />
        <SkeletonText width="50%" style={{ height: 12 }} />
      </Meta>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

const ThumbnailPlaceholder = styled(SkeletonBlock)`
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: ${cornerStyleInterpolationFactory({
    square: '0px',
    rounded: '10px',
    pill: '18px',
  })};
`;

const Meta = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 50px;
`;
